/**
 * CDC-mandated copy shown when the backend rejects a request with HTTP 403.
 */
export const FORBIDDEN_USER_MESSAGE = "Vous n'avez pas les droits pour cette action.";

/**
 * Returns the CDC-mandated forbidden message when the error carries a 403 status,
 * or `null` for any other error.
 */
export function readForbiddenUserMessage(error: {
  response?: { status?: number; data?: { message?: string } };
}): string | null {
  if (error.response?.status !== 403) return null;
  return FORBIDDEN_USER_MESSAGE;
}
